import { render, staticRenderFns } from "./RunnitBoardSkeleton.vue?vue&type=template&id=2b095c0b&scoped=true"
import script from "./RunnitBoardSkeleton.vue?vue&type=script&lang=ts"
export * from "./RunnitBoardSkeleton.vue?vue&type=script&lang=ts"
import style0 from "./RunnitBoardSkeleton.vue?vue&type=style&index=0&id=2b095c0b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b095c0b",
  null
  
)

export default component.exports